import React, { PureComponent, Fragment } from 'react';
import queryString from 'query-string';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import Stepper from './Stepper';
import CircleTick from '../../svg/CircleTick';
import Exclamation from '../../svg/Exclamation';
import styles from './stepsstyles';
import asyncSessionStorage from '../../../utils/asyncSessionStorage';
import { MARKETING_TAGS, PEP_STATUS, SESSION_URL } from '../../../constants';
import UploadIdDocumentsSuccess from './UploadIdDocumentsSuccess';

const setSearchParamsToSessionStorage = async (parsedSearch) => {
  await asyncSessionStorage.setItem(MARKETING_TAGS, JSON.stringify(parsedSearch));
};

const removeMarketingTags = async () => {
  await asyncSessionStorage.removeItem(MARKETING_TAGS);
};

class Steps extends PureComponent {
  componentDidMount() {
    const { restart, workflow } = this.props;
    const parsedUrl = this.getSessionUrlParsed();
    const isQueryParamsExist =
      (this.props.location && this.props.location.search) ||
      (parsedUrl && Object.keys(parsedUrl.query).length !== 0);

    if (workflow.completedSteps && !workflow.completedSteps.length) {
      if (isQueryParamsExist) {
        const parsedSearch = this.getParsedUrlQuery();
        if (parsedSearch && parsedSearch.referral_code) {
          setSearchParamsToSessionStorage(parsedSearch).then(() => {
            this.props.history.push(
              `/referral-welcome?referral_code=${parsedSearch.referral_code}`,
            );
          });
        } else {
          setSearchParamsToSessionStorage(parsedSearch).then(() => {
            restart(this.props.location);
          });
        }
      } else {
        removeMarketingTags().then(() => {
          restart();
        });
      }
    }
  }

  getParsedUrlQuery() {
    const parsedUrl = this.getSessionUrlParsed();
    if (this.props.location && this.props.location.search) {
      return queryString.parse(this.props.location.search);
    }
    if (parsedUrl && Object.keys(parsedUrl.query).length !== 0) {
      return parsedUrl.query;
    }
    return '';
  }

  getSessionUrlParsed = () => {
    const sessionUrl = asyncSessionStorage.getItemSync(SESSION_URL);
    const parsedUrl = sessionUrl && queryString.parseUrl(sessionUrl);
    return parsedUrl;
  };

  renderSteps() {
    const { classes, workflow } = this.props;

    return (
      <Grid container justify="center" alignItems="center">
        <Grid item xs={12}>
          <Card className={classes.container}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Stepper activeStepIndex={workflow.activeMainStepIndex} steps={workflow.steps} />
              </Grid>
              <Grid item xs={12}>
                <Switch>
                  {workflow.steps.map((step) =>
                    step.path.map((path) => (
                      <Route
                        key={path}
                        exact={step.exact}
                        path={path}
                        render={(props) => <step.component {...props} {...step.props} />}
                      />
                    )),
                  )}
                </Switch>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    );
  }

  renderAlert() {
    const { classes, workflow, restart } = this.props;
    let alerts;

    if (workflow.isBlocked) {
      alerts = (
        <Fragment>
          <Grid item xs={12} className={classes.iconcontainer}>
            <Exclamation />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3" className={classes.message} data-testid="workflowMessage">
              {workflow.message}
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.alertFooter}>
            <Link
              component="button"
              onClick={restart}
              className={classes.restartLink}
              data-testid="back"
            >
              Back
            </Link>
          </Grid>
        </Fragment>
      );
    } else if (workflow.isSuccess) {
      if (
        this.props.isIdVerificationAttemptsMaxed ||
        this.props.isPotentialAMLIdentified ||
        this.props.pepStatus === PEP_STATUS.SuspectedPEP
      ) {
        alerts = <UploadIdDocumentsSuccess classes={classes} />;
      } else {
        alerts = (
          <Fragment>
            <Grid item xs={12} className={classes.iconcontainer}>
              <CircleTick />
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <Typography variant="h3" className={classes.message} data-testid="workflowMessage">
                {workflow.message}
              </Typography>
            </Grid>
          </Fragment>
        );
      }
      removeMarketingTags();
    } else {
      alerts = null;
    }

    return (
      <Grid container justify="center" alignItems="center">
        <Grid item xs={12} md={4} lg={4} xl={4}>
          <Card className={classes.alertContainer} data-testid="alertContainer">
            <Grid container spacing={0} alignContent="center">
              {alerts}
            </Grid>
          </Card>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { workflow } = this.props;
    if (workflow.isBlocked || workflow.isSuccess) {
      return this.renderAlert();
    }
    return this.renderSteps();
  }
}

Steps.propTypes = {
  location: ReactRouterPropTypes.location.isRequired,
  classes: PropTypes.object.isRequired,
  workflow: PropTypes.object.isRequired,
  restart: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withRouter(withStyles(styles)(Steps));
